/* eslint-disable no-unused-vars */
/* eslint-disable-next-line no-unused-vars */
import { getApplications, saveApplication, getUsers, updatestatus } from '../../services/applicationService';
import _ from "lodash";
const state = {
    applications: {},
    users: {}
}

const getters = {
    getUsers(state) {
        return state.users;
    },
    getApplications(state) {
        return state.applications;
    }
}

const actions = {
    getApplications({ commit }, application) {
        return new Promise((resolve, reject) => {
            getApplications(application).then(response => {
                if(response.status==200){
                    let result=_.clone(response.data.data.pageResult);
                    let  appresponse = result.map(el => ({ ...el, status:el.isActive?'Active':'InActive'}))  
                    appresponse.totalRecords = response.data.data.totalRecords;
                    appresponse.pageNo = response.data.data.pageNo;              
                    commit('setApplications', appresponse);
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    saveApplication({ commit }, application) {
        return new Promise((resolve, reject) => {
            saveApplication(application).then(response => {
                if(response.status==200){
                    let applications = _.clone(state.applications);
                    let result = _.clone(response.data.data);
                    if (!application.IsEditMode) {
                        applications.push(result);
                        commit('setApplications', applications);
                    }
                    resolve();
                }
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    getUsers({ commit }, user) {
        return new Promise((resolve, reject) => {
            getUsers(user).then(response => {
                commit('setUsers', response.data.data);
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },
    updatestatus({ commit }, application) {
        return new Promise((resolve, reject) => {
            updatestatus(application).then(response => {
                resolve();
            })
                .catch(error => {
                    reject(error);
                });
        });
    },

}

const mutations = {
    setApplications(state, response) {
        state.applications = response;
    },
    setUsers(state, response) {
        state.users = response;
    }
}

export default {
    namespaced: true,
    actions,
    getters,
    mutations,
    state,
}